<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">Analytics</h6>
          </div>
          <div class="form-group ml-auto">
            <date-range-picker
                style="width: 100%;"
                ref="picker"
                class="form-control"
                :opens="dateRangeConf.opens"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :minDate="dateRangeConf.minDate" :maxDate="dateRangeConf.maxDate"
                :singleDatePicker="dateRangeConf.singleDatePicker"
                :timePicker="dateRangeConf.timePicker"
                :timePicker24Hour="dateRangeConf.timePicker24Hour"
                :showWeekNumbers="dateRangeConf.showWeekNumbers"
                :showDropdowns="dateRangeConf.showDropdowns"
                :autoApply="dateRangeConf.autoApply"
                v-model="expiryDate"
                @update="getOnLoadMessageLogs"
            >
            </date-range-picker>
          </div>
          <div class="form-group ml-auto">
            <!--            <label for="integrated_number" class="col-form-label">Integrated Number <span-->
            <!--                class="text-danger">*</span></label>-->
            <select class="form-control" id="integrated_number" v-model="integrated_number"
                    @change="getOnLoadMessageLogs" required>
              <option v-for="(option, key) in phones" :value="option.whatsAppId" :key="key">{{ option.name }}
                (+91 {{ option.phonenumber }})
              </option>
            </select>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="text-bold">
            <tr>
              <th scope="col">START</th>
              <th scope="col">END</th>
              <th scope="col">SENT</th>
              <th scope="col">DELIVERED</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tables" :key="row.id">
              <td>{{ format_date(new Date(row.start)) }}</td>
              <td>{{ format_date(new Date(row.end)) }}</td>
              <td>{{ row.sent }}</td>
              <td>{{ row.delivered }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import DateRangePicker from 'daterange-picker-vue3'
//you need to import the CSS manually
import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'

export default {
  components: {
    DateRangePicker
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    // 15th two months prior
    // const minDate = new Date(today)
    // minDate.setMonth(minDate.getMonth() - 2)
    // minDate.setDate(15)

    // 15th in two months
    const maxDate = new Date(today)
    const nextFollowDate = new Date()
    const yesterdayDate = new Date()
    const sevenDate = new Date()
    // maxDate.setMonth(maxDate.getMonth() + 2)
    // maxDate.setDate(now.getDate() + 15)
    nextFollowDate.setDate(now.getDate() + 3)
    yesterdayDate.setDate(now.getDate() - 1)
    sevenDate.setDate(now.getDate() - 7)
    return {
      dateRangeConf: {
        opens: 'center',
        minDate: 'center',
        maxDate: maxDate,
        singleDatePicker: false,
        timePicker: false,
        timePicker24Hour: false,
        showWeekNumbers: false,
        showDropdowns: false,
        autoApply: false,
      },
      expiryDate: {
        'startDate': maxDate,
        'endDate': maxDate
      },
      form: {
        template: 'hellow_world',
        campaign: 'campaign',
        referrel: 'referrel',
        source: 'source',
        fileUpload: null,
      },
      tables: [],
      phones: [],
      waId: "",
      integrated_number: "105991995863083",
      show: true
    }
  },
  async created() {
    this.waId = this.$route.params.waId
    var getWaId = await this.getNumberIntegrationList();
    this.phones = getWaId.data.message;
    var getTemp = await this.getMessageAnalytics();
    this.tables = getTemp.data.data.analytics.data_points;
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment((value * 1000)).format('DD-MM-YYYY hh:mm:ss a')
      }
    },
    async getMessageAnalytics() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/message_analytics';
      return await this.axiosRequest(templateURL, {
        expiryDate: {
          startDate: new Date(moment(this.expiryDate.startDate).format('YYYY-MM-DD 00:00:00')).toISOString(),
          endDate: new Date(moment(this.expiryDate.endDate).format('YYYY-MM-DD 23:59:59')).toISOString()
        },
        waId: this.integrated_number
      });
    },
    async getNumberIntegrationList() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    },
    async getOnLoadMessageLogs() {
      var getTemp = await this.getMessageAnalytics();
      this.tables = getTemp.data.data.analytics.data_points;
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
